import type { ProgramId } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const useProgram = (programId: ProgramId) => {
  const client = useGyymClient()
  return useGyymSWR([client.user.programs.get, programId])
}
